module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row bs-wizard",
    staticStyle: {
      "border-bottom": "0"
    }
  }, _vm._l((_vm.steps), function(step) {
    return _c('div', {
      key: step,
      staticClass: "bs-wizard-step col",
      class: [_vm.currentStep > (step + 1) ? 'complete' : '', _vm.currentStep == (step + 1) ? 'active' : '', _vm.currentStep < (step + 1) ? 'disabled' : ''],
      on: {
        "click": function($event) {
          _vm.stepClick(step)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "slot-wrapper"
    }, [_vm._t(step + 1)], 2), _vm._v(" "), _c('a', {
      staticClass: "bs-wizard-dot"
    }, [_c('strong', [_vm._v(_vm._s(step + 1))])])])
  }))
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0953c3b7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StepBar.vue
// module id = 980
// module chunks = 1